import { api } from 'shared/api'

import { templateApiSchemas } from './schema'

export const templateApi = {
  fetch: api.base.createGet({
    url: '/template/list',
    schemas: templateApiSchemas.fetch,
  }),
  delete: api.base.createPost({
    url: '/template/delete',
    schemas: templateApiSchemas.delete,
  }),
  create: api.base.createPost({
    url: '/template/create',
    schemas: templateApiSchemas.create,
  }),
  fetchTemplate: api.base.createGet({
    url: '/template/getData',
    schemas: templateApiSchemas.fetchTemplate,
  }),
  setTitle: api.base.createPost({
    url: '/template/setTitle',
    schemas: templateApiSchemas.setTitle,
  }),
  setShare: api.base.createPost({
    url: '/template/setShare',
    schemas: templateApiSchemas.setShare,
  }),
  setDescription: api.base.createPost({
    url: '/template/setDescription',
    schemas: templateApiSchemas.setDescription,
  }),
  update: api.base.createPost({
    url: '/template/update',
    schemas: templateApiSchemas.update,
  }),
  updateAvatar: api.base.createPost({
    url: '/template/updateAvatar',
    schemas: templateApiSchemas.updateAvatar,
  }),
  generateLink: api.base.createPost({
    url: '/template/generateLink',
    schemas: templateApiSchemas.generateLink,
  }),
  setShareType: api.base.createPost({
    url: '/template/setShareType',
    schemas: templateApiSchemas.setShareType,
  }),
  setIsProtected: api.base.createPost({
    url: '/templateInstallation/setIsProtected',
    schemas: templateApiSchemas.setIsProtected,
  }),
  uploadImage: api.base.createPost({
    url: '/template/uploadImage',
    schemas: templateApiSchemas.uploadImage,
  }),
}
